import styled from 'styled-components'
import { desktop, mobile } from '../../styles/media'

const WantsOnImage = styled.div`
	position: absolute;
	right: -0.25rem;
	top: -0.25rem;

	background: ${props => props.theme.id === 'dark' ? props.theme.backgroundVeryLight : 'rgba(0, 0, 0, 0.95)'};
	border-radius: 12px;
	font-size: 0.8rem;
	font-weight: 800;
	letter-spacing: 1px;
	line-height: 1;

	color: ${props => props.theme.red};

	height: 24px;
	width: 24px;

	align-items: center;
	display: flex;
	justify-content: center;

	svg {
		height: 16px;
		width: 16px;
	}

	${props => props.large && `
		border-radius: 20px;
		height: 40px;
		width: 40px;

		right: -0.5rem;
		top: -0.5rem;

		svg {
			height: 24px;
			width: 24px;
		}
	`}

	${props => props.empty && `
		color: rgba(255, 255, 255, 0.5);
	`}

	${props => props.loading && `
		pointer-events: none;
		opacity: 0.5;
	`}

	${desktop`
		${props => props.empty && `
			opacity: 0;
		`}
	`}

	${mobile`
		font-size: 0.7rem;
		padding: 0 0.15rem;

		height: 20px;
		width: 20px;

		svg {
			height: 14px;
			width: 14px;
		}

		${props => props.large && `
			border-radius: 15px;
			height: 30px;
			width: 30px;

			right: -0.5rem;
			top: -0.5rem;

			svg {
				height: 20px;
				width: 20px;
			}
		`}
	`}
`

export default WantsOnImage
